import React, { Component } from 'react';
import { Editor as MonacoEditor } from '@monaco-editor/react';

import Header from './Header';
import Footer from './Footer';
import styles from './Editor.scss';

const mode = {
  python3: 'python',
  javascript: 'javascript',
  c: 'c',
  cpp: 'cpp',
  java: 'java',
  ruby3: 'ruby',
};

class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: null,
      editor: null,
      monaco: null,
      constrainedInstance: null,
      url: window.location.href,
    };
  }

  componentDidUpdate(previousProps) {
    if (
      this.state.model &&
      (previousProps.lang !== this.props.lang ||
        (this.state.url !== window.location.href && this.props.code !== previousProps.code))
    ) {
      const code = this.props.code || '';
      this.state.model.setValue(code);
      if (this.state.url !== window.location.href && this.props.code !== previousProps.code)
        this.setState({ url: window.location.href });
    }

    if (
      previousProps.disableCopyPaste !== this.props.disableCopyPaste &&
      this.props.disableCopyPaste &&
      this.state.editor &&
      this.state.monaco
    ) {
      this.disableCopyPaste(this.state.editor, this.state.monaco);
    }
  }

  onCodeInEditorChange = code => {
    this.props.updateCode(code);
  };

  codeReset = () => {
    this.props.updateCode(this.props.activeTemplate.body);
  };

  disableCopyPaste = (editor, monaco) => {
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyC, () => {});
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyV, () => {});
    editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyX, () => {});

    const domNode = editor.getDomNode();
    domNode.addEventListener('copy', e => e.preventDefault(), true);
    domNode.addEventListener('paste', e => e.preventDefault(), true);
    domNode.addEventListener('cut', e => e.preventDefault(), true);
  };

  handleEditorMount = (editor, monaco) => {
    const model = editor.getModel();
    this.setState({ model, editor, monaco });

    if (this.props.disableCopyPaste) {
      this.disableCopyPaste(editor, monaco);
    }
  };

  render() {
    return (
      <div className={styles['c-editor']}>
        <Header
          selectedLanguage={this.props.selectedLanguage}
          editorExpand={this.props.editorExpand}
          languageList={this.props.languageList}
          switchLanguage={this.props.switchLanguage}
          toggleExpand={this.props.toggleExpand}
          toggleTheme={this.props.toggleTheme}
          codeReset={this.codeReset}
          theme={this.props.theme}
          onDriverCodeModalToggle={this.props.onDriverCodeModalToggle}
        />
        <div
          className={styles['c-editor__ace']}
          style={{ backgroundColor: this.props.theme === 'vs-dark' ? '#1e1e1e' : '#fff' }}
          data-testid="code-editor-container"
        >
          <MonacoEditor
            language={mode[this.props.lang]}
            theme={this.props.theme}
            onChange={this.onCodeInEditorChange}
            options={{
              highlightActiveLine: false,
              showPrintMargin: false,
              dragAndDrop: false,
              tabSize: 4,
              scrollBeyondLastLine: false,
              renderFinalNewline: false,
              minimap: { enabled: false },
              contextmenu: !this.props.disableCopyPaste,
            }}
            value={this.props.code}
            height="100%"
            width="100%"
            onMount={this.handleEditorMount}
          />
        </div>
        <Footer
          submitCode={this.props.submitCode}
          disabled={this.props.disabled}
          codeReset={this.codeReset}
          theme={this.props.theme}
        />
      </div>
    );
  }
}

export default Editor;
